export function addColon(text: string | undefined): string {
  if (!text) {
    return "";
  }
  if (!text.endsWith(":")) {
    return `${text}:`;
  }
  return text;
}

export const getFullName = ({
  firstName,
  lastName,
}: {
  firstName: string | undefined;
  lastName: string | undefined;
}) => {
  return `${firstName || ""} ${lastName || ""}`;
};
